import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';
import { Toast } from "@kaleyra/emmy";

export const EMAIL_STATUS_LOADING = "EMAIL_STATUS_LOADING";
export const EMAIL_STATUS_FAILED = "EMAIL_STATUS_FAILED";
export const EMAIL_STATUS_SUCCESS = "EMAIL_STATUS_SUCCESS";
export const EMAIL_FROM_LIST_SUCCESS = "EMAIL_FROM_LIST_SUCCESS";
export const EMAIL_FROM_LIST_FAILED = "EMAIL_FROM_LIST_FAILED";
export const getEmailStatus = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: EMAIL_STATUS_LOADING });

        let failedType: string = EMAIL_STATUS_FAILED;

        let url: string = `/email/status-list`;

        networkCall("get", url, apiBaseUrl.baseUrl, true, true)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: EMAIL_STATUS_SUCCESS, payload: { response: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }

}

export const getFromAddressList = ()=>{
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: EMAIL_STATUS_LOADING });

        let failedType: string = EMAIL_FROM_LIST_FAILED;

        let url: string = `/email/sender-list`;

        networkCall("get", url, apiBaseUrl.baseUrl, true, true)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: EMAIL_FROM_LIST_SUCCESS, payload: { response: res } });
                } else {
                    dispatch({ type: failedType, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: failedType, payload: { error: error.response.data } });
                }
            });
    }
}